import { DealerLocationID } from "./DealerLocation";

export interface TyreMotionAIUsage {
  dealer_location_id: DealerLocationID; // Dealer Location Identifier
  year: number; // Year of usage, format: YYYY
  month: number; // Month of usage
  api_call_count: number; // Total number of times, tyre motion ai api has been called
  wo_count: number; // Total workorder which used tyre motion ai
  no_tyre_match_count: number; // Total count when tyre didn't match'
  partial_reading_count: number; // Total number of times, tyre motion ai detected partially
  no_reading_count: number; // Total number of times, tyre motion ai could not read
  failed_processing_count: number; // Total number of times, tyre motion ai failed to process the image
}
